import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const InpcListTable = ({
  children,
  count,
  company,
  permissions,
  handleToggle = () => {},
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'year', text: t('inpc.fields.year') + ': ', type: 'h3' },
    { parent: 'values', variable: '1', text: t('months.1') + ': ' },
    { parent: 'values', variable: '2', text: t('months.2') + ': ' },
    { parent: 'values', variable: '3', text: t('months.3') + ': ' },
    { parent: 'values', variable: '4', text: t('months.4') + ': ' },
    { parent: 'values', variable: '5', text: t('months.5') + ': ' },
    { parent: 'values', variable: '6', text: t('months.6') + ': ' },
    { parent: 'values', variable: '7', text: t('months.7') + ': ' },
    { parent: 'values', variable: '8', text: t('months.8') + ': ' },
    { parent: 'values', variable: '9', text: t('months.9') + ': ' },
    { parent: 'values', variable: '10', text: t('months.10') + ': ' },
    { parent: 'values', variable: '11', text: t('months.11') + ': ' },
    { parent: 'values', variable: '12', text: t('months.12') + ': ' },
    ,
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.inpc.update',
    togglePermission: 'acl.inpc.toggle',
    editUrl: 'inpc', //Url para editar empleado
    propsName: 'inpc', //de donde se obtienen los props
    company: company,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };
  console.log(dataCard);

  return (
    <Common.List bordered dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="year"
            handleOrderChange={handleOrderChange}
          >
            {t('inpc.fields.year')}
          </Common.ThSortable>
          <th className="text-center">{t('months.1')}</th>
          <th className="text-center">{t('months.2')}</th>
          <th className="text-center">{t('months.3')}</th>
          <th className="text-center">{t('months.4')}</th>
          <th className="text-center">{t('months.5')}</th>
          <th className="text-center">{t('months.6')}</th>
          <th className="text-center">{t('months.7')}</th>
          <th className="text-center">{t('months.8')}</th>
          <th className="text-center">{t('months.9')}</th>
          <th className="text-center">{t('months.10')}</th>
          <th className="text-center">{t('months.11')}</th>
          <th className="text-center">{t('months.12')}</th>
          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={14} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(InpcListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/list/InpcListTable.js